import React from 'react';
import './recalls-ymm-modal.scss';
import { FMButton, FMModal } from '@own/fds-react';
import PreImagineYmmSelector from '../../../components/sections/pre-imagine-components/pre-imagine-vehicle-selector/pre-imagine-ymm-selector/pre-imagine-ymm-selector';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import { useAnalytics } from '../../../hooks/use-analytics';
interface Props {
    content: RecallsUnitedContent;
    className?: string;
    isTertiaryButton?: boolean;
}
export const RecallsYmmModal = (props: Props) => {
    const { content, className, isTertiaryButton } = props;
    const [isVisible, setIsVisible] = React.useState(false);
    const [fireEvents] = useAnalytics();
    const recallsResultsCtaClickEvent = 'recalls-results-cta';
    const ymmMessageParts = content.ymmCtaToModalLabel?.split(/<<|>>/);
    return (
        <>
            {content.ymmCtaToModalLabel && (
                <div className={className}>
                    <FMModal
                        name="fm-recalls-ymm-modal"
                        preventClose={false}
                        onClose={() => setIsVisible(false)}
                        closeButtonAriaLabel=""
                        isVisible={isVisible}
                    >
                        <div className="recalls-ymm-modal-content">
                            <div className="recalls-ymm-modal-header">
                                <div className="recalls-ymm-modal-title">
                                    {content.modalTitle}
                                </div>
                                <div className="recalls-ymm-modal-subtitle">
                                    {content.modalDescription}
                                </div>
                            </div>

                            <PreImagineYmmSelector
                                ariaLabel={''}
                                yearDropdownLabel={content.yearDropdownLabel}
                                modelDropdownLabel={content.modelDropdownLabel}
                                submitLabel={content.submitLabel}
                                options={[]}
                                page="RecallsUnited"
                                redirectData={{
                                    id: 'recalls-united',
                                    path: '',
                                }}
                                ymmSubmitEvent={() => setIsVisible(false)}
                            />
                            <p className="recalls-ymm-modal-disclaimer">
                                {content.ymmDisclaimer}
                            </p>
                        </div>
                    </FMModal>

                    {isTertiaryButton ? (
                        <FMButton
                            type="tertiary"
                            label={content.authYmmCtaToModalLabel}
                            onClick={() => setIsVisible(true)}
                        />
                    ) : (
                        <div className="recalls-ymm-modal-copy-and-button">
                            {ymmMessageParts?.[0]}
                            {ymmMessageParts[1] && (
                                <button
                                    className="recalls-ymm-button"
                                    onClick={() => {
                                        setIsVisible(true);
                                        fireEvents(
                                            recallsResultsCtaClickEvent,
                                            undefined,
                                            {
                                                ctaType: ymmMessageParts[1],
                                            },
                                            false
                                        );
                                    }}
                                >
                                    {ymmMessageParts[1]}
                                </button>
                            )}
                            {ymmMessageParts?.[2]}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default RecallsYmmModal;
